@if (component) {
<div [grid]="5"
     [gridColumnGap]="'40px'"
     [gridRowGap]="'40px'">
    @for (column of component.columns; track column) {
    <div>
        @for (submenu of column.submenus; track submenu) {
        <div class="p-b"
             [class]="!$first ? 'p-t b-t b-col-5' : ''">
            @switch (submenu.layout) {
            <!-- layout: links -->
            @case (ESubmenuLayout.links) {
            <!-- title -->
            <p class="s1 col-1 m-b"
               *iCms="'title' of submenu; skipEmpty: true"></p>
            <!-- links -->
            @for (line of submenu.linksList; track line) {
            <href class="block"
                  [class]="!$first ? 'm-t-3' : ''"
                  [link]="line.link">
                <p class="p1 _link col-11"
                   *iCms="'text' of line"></p>
            </href>
            }
            @if (submenu.ctaCopy) {
            <href class="m-t block"
                  [link]="submenu.link">
                <span [buttonStyle]="'text-button'"
                      [icon]="'arrow-right'">
                    <span *iCms="'ctaCopy' of submenu"></span>
                </span>
            </href>
            }
            }
            @case (ESubmenuLayout.linksWithDescription) {
            <p class="s1 col-1 m-b"
               *iCms="'title' of submenu; skipEmpty: true"></p>

            <!-- links -->
            @for (line of submenu.linksWithDescriptionList; track line) {
            <href [class.m-t-2]="!$first"
                  [link]="line.link">
                <div
                     class="p-t-2 p-b-2 p-l p-r m-t-2 flex flex-middle flex-justify-between b-a b-col-5 _link-with-description">
                    <div>
                        <p class="p1 col-1"
                           *iCms="'text' of line"></p>
                        <p class="c1 col-11 m-t-1"
                           *iCms="'description' of line"></p>
                    </div>
                    <i class="col-1"
                       style="font-size:28px"
                       [class]="line.icon"></i>
                </div>
            </href>
            }
            @if (submenu.ctaCopy) {
            <button class="m-t"
                    [buttonStyle]="'text-button'"
                    [icon]="'arrow-right'">
                <span *iCms="'ctaCopy' of submenu"></span>
            </button>
            }
            }

            @case (ESubmenuLayout.image) {
            <href class="block _image-container"
                  [link]="submenu.link">
                <div class="w-12 _image">
                    <!-- alt="" is deliberate: the sibling title below already
                         names this link for assistive tech -->
                    <img class="w-12"
                         [ratio]="submenu.ratio"
                         [dfImage]="submenu.image"
                         alt="">
                </div>
                <p class="s1 col-11 _title center m-t-2"
                   *iCms="'title' of submenu; skipEmpty:true"></p>
            </href>
            }

            @case (ESubmenuLayout.promoBanner) {
            <href class="b-a block b-col-5 _promobanner"
                  (mouseenter)="toggleActive(true)"
                  (mouseleave)="toggleActive(false)"
                  [link]="submenu.link">
                <span class="w-12">
                    <img class="w-12"
                         [ratio]="submenu.ratio"
                         [dfImage]="submenu.image"
                         alt="">
                </span>
                <div class="p-a-2">
                    <p class="s1 col-1"
                       *iCms="'title' of submenu; skipEmpty:true"></p>
                    <p class="m-t-1 p2 col-11"
                       *iCms="'description' of submenu; skipEmpty:true"></p>
                    @if (submenu.ctaCopy) {
                    <span class="m-t-2"
                          [class.active]="bannerActive() ? true : null"
                          [buttonStyle]="'text-button'">
                        <span *iCms="'ctaCopy' of submenu"></span>
                    </span>
                    }
                </div>
            </href>
            }
            }
        </div>
        }
    </div>
    }
</div>
}